import React from 'react'
import { Button, Grid, Typography, Box } from '@mui/material'
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { useNavigate } from 'react-router';

/** 
 * 
 * This component is expecting the following input. 

*/

const HealthShelfComponent = (props) => {

    const { HealthShelfIcon, HealthShelfLink, HealthShelfText, HealthShelfTitle } = props.HealthShelfFrame

    const navigate = useNavigate();

    return (
        <Box mt={2}>
            <Box pb={3}>
                <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                    <Grid item xs={12}>
                        <Box sx={{ alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "row" }} onClick={() => navigate('/healthshelf')}>
                            <MenuBookIcon sx={{ fontSize: 150 }} />
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "row" }} onClick={() => navigate('/healthshelf')}>
                            <Typography variant="h6" align="center" dangerouslySetInnerHTML={{ __html: HealthShelfTitle }}></Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "row" }} onClick={() => navigate('/healthshelf')}>
                            <Typography variant="body1" align="center" dangerouslySetInnerHTML={{ __html: HealthShelfText }}></Typography>

                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "row" }}>
                            <Button variant="contained" onClick={() => navigate('/healthshelf')}>{HealthShelfLink}</Button>
                        </Box>
                    </Grid>
                </Grid >
            </Box>
        </Box>
    )
}

export default HealthShelfComponent